import { PlaceholderPage } from './PlaceholderPage';

export const AuditLogPage = () => <PlaceholderPage title="Audit Log" />;
